import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, useSearchParams } from 'react-router-dom'
import banner from '../../images/banners/login.jpg'
import loading from '../../images/spin.gif'
import BACKEND_URL from '../../api'

export default function Reset_password() {
    const navigate = useNavigate()
    const [users, setusers] = useState()
    const [useremail, setuseremail] = useState()

    const [msg, setmsg] = useState()
    const [searchParams, setSearchParams] = useSearchParams();
    const [loadingshow, setloadingshow] = useState(false)
    const [reset, setreset] = useState(searchParams.get("ref"))

    function resetpass() {
        if (useremail != "") {
            setloadingshow(true)

            fetch(`${BACKEND_URL}/resetPassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_email: useremail,
                }),
            })
                .then((response) => {
                    // Check if the response is ok (status in the range 200-299)
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    setloadingshow(false);
                    if (data.status === "1") {
                        setmsg(data.message);
                        seterrormsg("")
                    } else {
                        seterrormsg(data.message);
                        setmsg("")
                    }
                })
                .catch((err) => console.log(err));
        } else {
            console.log("Enter username and password")
        }
    }

    const [collectionDetails, setcollectionDetails] = useState()
    const [errormsg, seterrormsg] = useState()
    const [errorcount, seterrorcount] = useState()
    function checkpassword(newpass) {
        if (collectionDetails.user_pass != newpass) {

            seterrormsg('Incorrect email or password. Please try again.')
            seterrorcount(1);
        } else {

            seterrormsg('')
            seterrorcount(0);
            setcollectionDetails({ ...collectionDetails, confirmpass: newpass })
        }

    }

    function resetpassword() {
        fetch(`${BACKEND_URL}/resetPassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                collectionDetails: collectionDetails,
                user: reset,
                type: "update"
            }),
        })
            .then((response) => {
                // Check if the response is ok (status in the range 200-299)
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                if (data.status === "1") {
                    navigate('/login');
                } else {
                    setmsg(data.message);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <Helmet>
                <title>Shypv | Reset Password</title>
            </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 your_business text-center">
                            <div className="business_content">
                                <h1 className="mainhead">RESET PASSWORD</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="pages_content">
                <div className="container">
                    {msg ? (
                        <p className="reset_message"> <span>{msg}</span></p>
                    ) : null}
                    {reset ? (
                        <div className="row">
                            <div className="col-md-3"></div>
                            <div className="col-md-6 loginbox" style={{ border: "1px solid", marginTop: "6%", marginBottom: "6%" }}>
                                <h5 className="resethead">Reset Password</h5>
                                <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                    <main id="main" className="site-main" role="main">

                                        <form>
                                            <p>Please enter your new password. </p>
                                            <input type="text" placeholder='Password' className="form-control mb-3" required onChange={(e) => setcollectionDetails({ ...collectionDetails, user_pass: e.target.value })} />
                                            <input type="text" placeholder='Confirm Password' className="form-control mb-3" required onChange={(e) => checkpassword(e.target.value)} />
                                            <p style={{ color: "red" }}>{errormsg}</p>
                                            <button type="button" className="btn  btn-sm" onClick={resetpassword} style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Reset Password</button>

                                        </form>
                                    </main>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-3"></div>
                            <div className="col-md-6 loginbox" style={{ border: "1px solid", marginTop: "6%", marginBottom: "6%" }}>
                                <h5 className="resethead">Reset Password</h5>
                                <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                    <main id="main" className="site-main" role="main">

                                        <form>
                                            <p>Please enter your email address . You will receive a link to create a new password via email.</p>
                                            <input type="text" placeholder='User Email' className="form-control mb-3" required onChange={(e) => setuseremail(e.target.value)} />

                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                <button type="button" className="btn btn-sm" onClick={resetpass} style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }}>Reset Password</button>
                                                {/* <Link className="loginaction" to="/register">Are you a member?</Link>
                                            <Link className="loginaction" to="/reset-password">Forgot Password</Link> */}
                                                <p className='loginaction' style={{ color: "red" }}>{errormsg}</p>
                                            </div>

                                            {loadingshow ? (
                                                <p style={{ textAlign: "center", marginTop: "2%" }}><img src={loading} style={{ width: "5%" }} /></p>
                                            ) : null}
                                        </form>
                                    </main>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
